import { render, staticRenderFns } from "./MealCategoryForm.vue?vue&type=template&id=2892ebd7"
import script from "./MealCategoryForm.vue?vue&type=script&lang=js"
export * from "./MealCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports